<template>
  <div>
    <vue-headful />
    <Header
      menuClass="invisible"
      :link="{ name: 'applicant-step_3', params: { action: 'save' } }"
    />
    <div class="px-4 mx-2 pb-4">
      <form @change="onFormChange" @submit.prevent="onSubmit">
        <div class="container-fluid px-0 pb-1 mb-2">
          <NotificationContainer />
          <div class="mb-4 pb-1">
            <p class>
              <strong>Omschrijving werkervaring (onderwijs)</strong>
            </p>
            <div class="form-group w-square-icon">
              <select
                class="custom-select"
                v-bind:class="[
                  this.required.includes('profession_id') && !form.profession_id
                    ? 'require'
                    : ''
                ]"
                v-model="form.profession_id"
                required
              >
                <option value selected disabled>Functieomschrijving</option>
                <option
                  v-for="profession in this.professionsList"
                  :key="profession.id"
                  :value="profession.id"
                  >{{ profession.name }}</option
                >
              </select>
              <div
                class="icon-wrapper dropdown position-absolute align-self-center border-left"
              >
                <svg-icon icon="chevron_s" />
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-bind:class="[
                  this.required.includes('company') ? 'require' : ''
                ]"
                placeholder="Organisatie"
                v-model="form.company"
                required
              />
            </div>
            <div class="form-group w-square-icon mb-0">
              <select
                class="custom-select"
                v-bind:class="[
                  this.required.includes('company') && !form.industry_id
                    ? 'require'
                    : ''
                ]"
                v-model="form.industry_id"
                required
              >
                <option value selected disabled
                  >Aan weke groep/klas gaf je les?</option
                >
                <option
                  v-for="field in this.workfieldList"
                  :key="field.id"
                  :value="field.id"
                  >{{ field.name }}</option
                >
              </select>
              <div
                class="icon-wrapper dropdown position-absolute align-self-center border-left"
              >
                <svg-icon icon="chevron_s" />
              </div>
            </div>
          </div>
          <div class="mb-2 pb-1">
            <p class>
              <strong>Werkzame periode</strong>
            </p>
            <div class="row">
              <div class="col-6 pr-2">
                <div>
                  <div class="form-group w-square-icon">
                    <input
                      type="text"
                      class="form-control calendar"
                      v-bind:class="[
                        this.required.includes('start_date') ? 'require' : ''
                      ]"
                      placeholder="Begin datum"
                      v-model="display_startDate"
                      required
                    />
                    <div
                      class="icon-wrapper calendar position-absolute align-self-center border-left"
                      v-on:click="fakeDatePicker('start')"
                    >
                      <i class="material-icons-round">calendar_today</i>
                    </div>
                    <div
                      class="syncfusion-calendar fake-datepicker"
                      v-if="calendar.start_date !== null"
                      v-show="this.calendar.show_start"
                    >
                      <div class="icon-wrapper arrow-back">
                        <i class="material-icons-round">arrow_back</i>
                      </div>
                      <div class="icon-wrapper arrow-forward">
                        <i class="material-icons-round">arrow_forward</i>
                      </div>
                      <ejs-calendar
                        :value="calendar.start_date"
                        :start="calendar.start"
                        :depth="calendar.depth"
                        :created="onStartChange"
                        :change="onStartChange"
                        :max="calendar.max_date"
                        :isMultiSelection="false"
                        :firstDayOfWeek="calendar.week"
                      ></ejs-calendar>
                      <!-- :showTodayButton="false" -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 pl-2">
                <div class="form-group w-square-icon">
                  <input
                    type="text"
                    class="form-control calendar"
                    v-bind:class="[
                      this.required.includes('end_date') ? 'require' : ''
                    ]"
                    placeholder="Eind datum"
                    v-model="display_endDate"
                    required
                  />
                  <div
                    class="icon-wrapper calendar position-absolute align-self-center border-left"
                    v-on:click="fakeDatePicker('end')"
                  >
                    <i class="material-icons-round">calendar_today</i>
                  </div>
                  <div
                    class="syncfusion-calendar fake-datepicker right"
                    v-show="this.calendar.show_end"
                  >
                    <div class="icon-wrapper arrow-back">
                      <i class="material-icons-round">arrow_back</i>
                    </div>
                    <div class="icon-wrapper arrow-forward">
                      <i class="material-icons-round">arrow_forward</i>
                    </div>
                    <ejs-calendar
                      :value="calendar.end_date"
                      :start="calendar.start"
                      :depth="calendar.depth"
                      :created="onEndChange"
                      :change="onEndChange"
                      :max="calendar.max_date"
                      :isMultiSelection="false"
                      :firstDayOfWeek="calendar.week"
                    ></ejs-calendar>
                    <!-- :showTodayButton="false" -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-4 pb-1">
            <p class>
              <strong>Omschrijving</strong>
            </p>
            <textarea
              class="form-control"
              placeholder="Vertel hier kort iets over het type onderwijs en bijvoorbeeld wat je hebt bereikt."
              rows="5"
              v-model="form.information"
            ></textarea>
          </div>
          <div class="form-group mb-4 pb-1">
            <p class>
              <strong>Extra curriculair</strong>
            </p>
            <textarea
              class="form-control"
              placeholder="Geef hier aan wat je nog meer hebt gedaan dat relevant kan zijn, zoals bv. voetbaltraining, zangles aan een groep kinderen, etc."
              v-model="form.extra"
              rows="5"
            ></textarea>
          </div>
          <button
            v-if="!this.id"
            type="submit"
            class="btn btn-warning btn-block"
          >
            Voeg werkervaring toe
          </button>
          <button
            v-if="this.id"
            type="submit"
            class="btn btn-warning btn-block"
          >
            Opslaan
          </button>
          <button
            v-if="this.id"
            @click="deleteWork"
            type="button"
            class="btn btn-gray btn-block"
          >
            Verwijder
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      professionsList: [],
      workfieldList: [],
      display_startDate: "",
      display_endDate: "",
      form: {
        id: "",
        profession_id: "",
        company: "",
        industry_id: "",
        start_date: "",
        end_date: "",
        information: "",
        extra: ""
      },
      required: [
        "profession_id",
        "company",
        "industry_id",
        "start_date",
        "end_date"
      ],
      calendar: {
        start_date: this.formatNoTime(),
        end_date: this.formatNoTime(),
        max_date: null,
        start: "Year",
        depth: "Year",
        show_start: false,
        show_end: false,
        week: 1
      }
    };
  },
  props: ["id"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.professionsList = await this.getAPIList("professions");
      this.workfieldList = await this.getAPIList("industries");
      await this.autoFillForm();
      this.$forceUpdate();
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        if (this.id) {
          const user = JSON.parse(localStorage.getItem("user"));
          const experiences = user.experiences;
          let ID = parseInt(this.id);
          var experience = experiences.find(obj => obj.id === ID);
          for (var key in this.form) {
            if (experience[key]) {
              this.form[key] = experience[key]; // update
            }
          }
          this.calendar.start_date = this.formatNoTime(this.form.start_date);
          this.calendar.end_date = this.formatNoTime(this.form.end_date);

          this.display_startDate = this.formatMMYYYY(this.form.start_date);
          this.display_endDate = this.formatMMYYYY(this.form.end_date);
        }
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          year = d.getFullYear();
        var last_day = new Date(year, month + 1, 0).getDate();
        this.calendar.max_date = new Date([month, last_day, year].join("/"));
        resolve();
      });
    },
    async onStartChange(args) {
      if (args && args.value) {
        if (args.value) {
          const new_date = this.formatDate(args.value, "start");
          this.calendar.start_date = this.formatNoTime(new_date);
          this.form.start_date = new_date;
          this.display_startDate = this.formatMMYYYY(args.value);
        }
        await this.compareDates("start");
        if (args.event) {
          if (args.event.type == "click") {
            localStorage.setItem("form-pending", JSON.stringify(true));
          }
        }
        this.calendar.show_start = false;
      }
    },
    async onEndChange(args) {
      if (args && args.value) {
        if (args.value) {
          const new_date = this.formatDate(args.value, "end");
          this.calendar.end_date = this.formatNoTime(new_date);
          this.form.end_date = new_date;
          this.display_endDate = this.formatMMYYYY(args.value);
        }
        await this.compareDates("end");
        if (args.event) {
          if (args.event.type == "click") {
            localStorage.setItem("form-pending", JSON.stringify(true));
          }
        }
        this.calendar.show_end = false;
      }
    },
    async saveWorkExperience() {
      return new Promise((resolve, reject) => {
        this.$store.state.loading = true;

        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }

        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/work";
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(success => {
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: success.data.message
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(error => {
            const notification = {
              type: "danger",
              message: error.response.data
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async deleteWork() {
      const ID = parseInt(this.id);
      await this.deleteRecord("/work/" + ID);
      // continue only if resolve()
      await this.updateLocalUser();
      await this.redirectBack();
    },
    async onSubmit() {
      window.scrollTo(0, 0);
      await this.saveWorkExperience();
      // continue only if resolve()
      await this.updateLocalUser();
      await this.redirectBack();
    },
    async redirectBack() {
      return new Promise(() => {
        setTimeout(
          () =>
            this.$router.replace({
              name: "applicant-step_3",
              params: { action: "save" }
            }),
          800
        );
      });
    },
    fakeDatePicker(target) {
      if (target == "start") {
        this.calendar.show_end = false;
        this.calendar.show_start = this.calendar.show_start ? false : true;
      } else if (target == "end") {
        this.calendar.show_start = false;
        this.calendar.show_end = this.calendar.show_end ? false : true;
      }
    },
    compareDates(target) {
      return new Promise(resolve => {
        var startDate = this.form.start_date;
        var endDate = this.form.end_date;
        if (startDate && endDate) {
          if (Date.parse(startDate) > Date.parse(endDate)) {
            // reset date
            if (target === "start") {
              this.display_startDate = "";
              this.form.start_date = "";
              this.calendar.start_date = null;
            } else if (target === "end") {
              this.display_endDate = "";
              this.form.end_date = "";
              this.calendar.end_date = null;
            }
          }
        }
        resolve();
      });
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));
    }
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped></style>
